/* import __COLOCATED_TEMPLATE__ from './create-color-row.hbs'; */
import { schedule } from "@ember/runloop";
import { classNames } from "@ember-decorators/component";
import { escapeExpression } from "discourse/lib/utilities";
import SelectKitRowComponent from "select-kit/components/select-kit/select-kit-row";
const CreateColorRow = dt7948.c(class CreateColorRow extends SelectKitRowComponent {
  didReceiveAttrs() {
    super.didReceiveAttrs(...arguments);
    schedule("afterRender", () => {
      const color = escapeExpression(this.rowValue);
      this.element.style.borderLeftColor = color.startsWith("#") ? color : `#${color}`;
    });
  }
}, [classNames("create-color-row")]);
export default CreateColorRow;